import { states } from "@consts/states";

export const getFullStateName = (stateCode: string): string => {
  const fullStateName = states.find(
    ({ value }) => value === stateCode.toUpperCase()
  )?.label;

  if (fullStateName === undefined) {
    throw new Error(
      "That state could not be found. Please double check your input."
    );
  }

  return fullStateName;
};
